import { useContext } from 'react';
import { HighlightContext } from '../';
import type { HighlightContextT } from './types';

export const useHighlight = (): HighlightContextT => {
  const data = useContext(HighlightContext);

  if (!data) {
    throw new Error('useHighlight was used outside of its Provider');
  }

  return data;
};
